import React from 'react'
import classNames from 'classnames';
import { Field, Form } from 'redux-form';
import { TextInputField, ResizableTextAreaField } from 'common/components/form_fields';
import Icon from 'common/components/svg_icon';

// TODO: Validate URLs

var ListItemForm = React.createClass({

  closeItemForm: function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.props.hideFullScreen();
  },

  submit(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.submit();
  },

  saveListItem(data) {
    this.props.saveListItem(data);
    this.closeItemForm();
  },

  render() {
    const { isURLSelector, itemName, initialValues } = this.props
    const editing = !!initialValues;

    return (
      <Form onSubmit={this.props.handleSubmit(this.saveListItem)} className="add-item-form">
        <button className="btn btn-icon-only btn-close" onClick={this.closeItemForm}>
          <Icon icon="close" extraClasses="svg-icon-lg" />
        </button>
        <h2>{ editing? 'Edit' : 'Add' } { itemName }</h2>

        <fieldset>
          <h3 className="pap-field-label">{isURLSelector ? "URL" : `Title for ${itemName}`}</h3>
          <Field component={TextInputField} name={isURLSelector? "url":"title"} {...this.props} />
        </fieldset>

        <fieldset>
          <h3 className="pap-field-label">Description</h3>
          <Field component={ResizableTextAreaField} name="description" {...this.props} />
        </fieldset>
        <div className="row">
          <div className="columns small-16">
            <button className="btn btn-tertiary" onClick={this.submit}>
              { editing? 'Update' : 'Add' }
            </button>
            <button className="btn btn-text" onClick={this.closeItemForm}>Cancel</button>
          </div>
        </div>
      </Form>
    )
  }
});

export default ListItemForm;
